import { Flex } from "../Flex/Flex";
import type { FlexProps } from "../Flex/types";

function VStack(props: FlexProps) {
    return <Flex direction="column" {...props} />;
}

export { VStack };
